import {FormValues} from '@wix/form-viewer'

interface BuildOverridesParams {
  initialValues: FormValues
  member: boolean
  useBuyerDetails?: boolean
}

export const buildOverrides = ({initialValues, member, useBuyerDetails}: BuildOverridesParams) => {
  let overrides = {}

  if (initialValues.email && member) {
    overrides = {email: {disabled: true}}
  }

  if (useBuyerDetails) {
    overrides = {
      ...overrides,
      first_name: {disabled: true},
      last_name: {disabled: true},
      email: {disabled: true},
    }
  }

  return overrides
}
